import { useGetCurrentUserQuery, useUserNavigationQuery } from '../store/user/userApi';
import { readFromStorage } from '../utils/webStorage';
import { isAuthRouteWithUsernameParam } from '../utils/authSession';


export const GuestGuard = (): boolean => {
    if (isAuthRouteWithUsernameParam()) {
        return true;
    }
    const token = readFromStorage('accessToken');
    if (token) {
        return false
    }
    else {
        return true
    }
};

export const SuperAdminGuard = (): boolean => {
    // const { data }: any = !role && useGetCurrentUserQuery();
    const token = readFromStorage('accessToken');
    return token ? (localStorage.getItem('roles') === 'super_admin') : false
};

export const AdminGuard = (): boolean => {
    // const { data }: any = !role && useGetCurrentUserQuery();
    const token = readFromStorage('accessToken');
    return token ? (localStorage.getItem('roles') === 'admins' || localStorage.getItem('roles') === 'partners' || localStorage.getItem('roles') === 'super_admin') : false
};

export const StaffGuard = (): boolean => {
    const token = readFromStorage('accessToken');
    return token ? (localStorage.getItem('roles') === 'staff') : false
};

export const PartnerAgentGuard = (): boolean => {
    const role = localStorage.getItem('roles')
    const { data }: any = !role && useGetCurrentUserQuery();
    const token = readFromStorage('accessToken');
    return token ? role ? (role === 'partners' || role === 'partner' || role === 'agents' || role === 'agent') : (data && data?.data?.type) ? data.data.type === 'partners' || data?.data.type === 'agents' || data?.data?.type === 'partner' || data?.data?.type === 'agent' : false : false;
};

export const PartnerGuard = (): boolean => {
    const role = localStorage.getItem('roles')
    const { data }: any = !role && useGetCurrentUserQuery();
    const token = readFromStorage('accessToken');
    return token ? role ? (role === 'partners' || role === 'partner') : (data && data?.data?.type) ? data?.data?.type === 'partners' || data?.data?.type === 'partner' : false : false;
};

export const PartnerRoutesGuard = (path: any): boolean => {
    const token = readFromStorage('accessToken');
    const dataRead = useUserNavigationQuery();
    const formatData = dataRead?.data
    const findParent = (formatData && formatData?.data && formatData?.data?.length > 0) ? formatData?.data?.find((item: any) => item?.path === path) : false
    if ((token ? localStorage.getItem('roles') === 'admins' : false) || !token) {
        return true
    }
    return !dataRead?.data?.data || !!findParent
};

export const PartnerChildRoutesGuard = (parentPath: any, childPath: any) => {
    const token = readFromStorage('accessToken');
    if ((token ? localStorage.getItem('roles') === 'admins' : false) || !token) {
        return true
    }
    const dataRead: any = useUserNavigationQuery();
    const formatData = dataRead?.data
    const findParent = (formatData?.data && formatData?.data?.length > 0) && formatData?.data?.find((item: any) => item?.path === parentPath)
    const findChild = findParent && findParent?.children && findParent?.children?.length > 0 && findParent?.children?.find((item: any) => item?.path === childPath)
    return !dataRead?.data?.data || !!findChild
}
